import { render, staticRenderFns } from "./MainHeartIcon.vue?vue&type=template&id=43e4ab70&scoped=true&"
import script from "./MainHeartIcon.vue?vue&type=script&lang=js&"
export * from "./MainHeartIcon.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "43e4ab70",
  null
  ,true
)

export default component.exports